import React from 'react';
import { Spinner } from 'reactstrap';

export default function SpinnerLoading({
  isLoading = true,
  grow = false,
  height = null,
  width = null,
  spinnerSize = '2rem',
  color = 'black',
}) {
  if (!isLoading) {
    return null;
  }

  const divStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...(grow && { flexGrow: 1 }),
    ...(height && { height }),
    ...(width && { width }),
  };

  return (
    <div
      style={{
        ...divStyle,
      }}
    >
      <Spinner
        style={{
          width: spinnerSize,
          height: spinnerSize,
          margin: 'auto',
          color,
        }}
      />
    </div>
  );
}
